<script lang="ts" setup>
const props = defineProps({
	text: {
		type: String,
		required: true,
	},
	action: {
		type: Function,
	},
	theme: {
		type: String,
		default: '',
	},
})

function onClick(event: MouseEvent) {
	if (props.action === undefined) return
	if (!props.action()) {
		event.preventDefault()
		event.stopPropagation()
	}
}
</script>

<template>
	<div class="bs-link-arrow-button" :class="theme" @click.capture="onClick">
		<p class="bs-link-arrow-button__text">{{ text }}</p>
		<i class="bs-link-arrow-button__icon"></i>
	</div>
</template>
